import { complex } from './basler-components.es795.js';
import { filter } from './basler-components.es813.js';
import { getDefaultValueType } from './basler-components.es812.js';

function getAnimatableNone(key, value) {
    let defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone
        ? defaultValueType.getAnimatableNone(value)
        : undefined;
}

export { getAnimatableNone };
